import React from 'react'
import FormularioAvaliacao from '../../../../components/performance/FormularioAvaliacao'

export default function AvaliacaoFormPage() {
  return (
    
            <FormularioAvaliacao />
          
  )
}
